export enum ScanningStatusEnum {
  AVAILABLE = 'available',
  BLOCKED = 'blocked',
  PROCESSING = 'processing',
  BYPASSED = 'bypassed',
}
